import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  px: '2',
  borderTop: '1px dashed rgba(0, 0, 0, 0.1)',
};
